import { Injectable } from "@angular/core";

import { DataService } from "@app-cmc/core/services/data.service";
import { Platform, PlatformAccount, Product } from "@app-cmc/models";
import { Observable } from "rxjs";
import { map, mergeMap } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class PlatformAccountService {
  private serviceUrl = "platform";
  constructor(private http: DataService) {}

  getPlatformAccountById(id: number): Observable<PlatformAccount> {
    return this.http.get(`${this.serviceUrl}/${id}`);
  }
  getAll(): Observable<Platform[]> {
    return this.http.get(`${this.serviceUrl}/allPlatforms`);
  }
  getPlatformAccounts(userId: number): Observable<PlatformAccount[]> {
    return this.http.get(`${this.serviceUrl}/userPlatformAccouns/${userId}`);
  }
  getAvaliableUserPlatforms(userId: number): Observable<Platform[]> {
    return this.getPlatformAccounts(userId).pipe(
      mergeMap((accounts) => {
        return this.getAll().pipe(map((platforms) => platforms.filter((p) => !accounts.some((ac) => ac.platformId === p.id))));
      })
    );
  }
  addPlatformAccount(account: PlatformAccount) {
    return this.http.post(`${this.serviceUrl}/addAccount`, account);
  }
  updatePlatformAccount(account: PlatformAccount) {
    return this.http.post(`${this.serviceUrl}/updateAccount`, account);
  }
  deletePlatformAccount(accountId: number) {
    return this.http.delete(`${this.serviceUrl}/deletePlatformAccount/${accountId}`);
  }

  getConfiguredProducts(): Observable<Product[]> {
    return this.http.get(`${this.serviceUrl}/allPredefinedProducts`);
  }
}
